<style  scoped>



</style>

<template>

<nav class="c-nav u-fixed u-pos-tl u-viewport-fit-h u-fit-w" style="display: none;">
  <div class="c-nav__renderer o-wrapper--panel u-fit u-backface-hidden js-render-panel">

  </div>
  <div class="c-nav__overlay o-wrapper--panel u-fit u-bg--brand-dark"></div>
  <img src="../../assets/medias/images/logo-simple-clear.svg" class="c-nav__logo u-absolute u-pos-tl u-marg-t-lg u-marg-l-w1of12 u-hide@sm">
  <div class="c-nav__links o-wrapper--panel o-wrapper--valign u-fit u-pad-l-w3of12">
    <div class="u-inline-block u-valign-middle">
      <ul class="c-nav__list o-list u-force-3d">

        <li class="c-nav__list__item" v-for="(item, index)  in content.nav.links"  :class="{'is-active':((activeIndex)===(index))}">
           <a     href="javascript:void(0)"    class="c-nav__list__link t-link t-text--roman u-color--white"      @mouseover="onItemOver(index)"  @touchstart="onItemOver(index)"    @click="onItemClick(index)">{{item.label}}</a>
         </li>
      </ul>
    </div>
  </div>
  <div class="c-nav__grain o-wrapper--panel u-fit u-pointer-none"></div>
</nav>
</template>

<script>

import Pixi from 'pixi.js'
import tweenManager from 'pixi-tween'
import router from '../../application/router.js'
import {cubic}  from '../../utilities/cubic'
import {clamp}  from '../../utilities/clamp'
import {cubicu} from '../../utilities/cubicu'
export default {
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
        content: {
            type: Object,
            default: function() {}
        },
        isActive: {
            type: Boolean,
            default: !1
        },
        activePageIndex: {
            type: Number,
            default: 0
        }
    },
    watch: {
        isActive: "onActiveChange"
    },
    data: function() {
        return {
            activeIndex: 0
        }
    },
    created: function() {
        this._inAnimRatio = 0,
            this._outAnimRatio = 0,
            this._currInAnimRatio = 0,
            this._currOutAnimRatio = 0,
            this._sceneWidth = 1600,
            this._sceneHeight = 900,
            this._direction = 1,
            this._translationIndex = 0,
            this._isRendering = !1,
            this._draw = 0,
            this.onResize = this.onResize.bind(this),
            this.onEnterframe = this.onEnterframe.bind(this),
            this.eventHub.$on("resize", this.onResize),
            this.eventHub.$on("enterframe", this.onEnterframe)
    },
    mounted: function()
    {
        this.$renderPanel = this.$el.querySelector(".js-render-panel"),
        this.loadTextures()
    },
    destroyed: function()
    {
        this.eventHub.$off("resize", this.onResize),
        this.eventHub.$off("enterframe", this.onEnterframe),
        this._stage.destroy(!0)
    },
    methods:
    {
                   loadTextures: function()
                   {

                      var t = this,
                      e = new PIXI.loaders.Loader(),
                      n = this.content.nav.links.length;
                       for (var r = 0; r < this.content.nav.links.length; r++)
                       {
                           var i = this.content.nav.links[r].image.src;
                           e.add(i, i)
                       }
                       e.on("progress", function()
                       {
                           t.eventHub.$emit("loader:progress")
                       }), e.once("complete", function() {
                           t.initScene()
                       }),
                       e.load(),
                       this.eventHub.$emit("loader:start", n)
                   },
                   initScene: function()
                   {
                       this._renderer = PIXI.autoDetectRenderer(1450, 900, {
                           backgroundColor: 1318185,
                           antialias: !1
                       }),
                       this._tilesContainer = new PIXI.Container(),
                        this._secondaryTilesContainer = new PIXI.Container(),
                        this._spritesContainer = new PIXI.Container(),
                        this._textContainer = new PIXI.Container(),
                         this._allTilesContainer = new PIXI.Container(),
                          this._container = new PIXI.Container(),
                          this.$renderPanel.appendChild(this._renderer.view),
                          this._tilesContainer.position.x = .5 * -this.$root.winWidth,

                          this._stage = new PIXI.Container(),
                          this._stage.addChild(this._tilesContainer),
                          this._stage.addChild(this._allTilesContainer),
                          this._stage.addChild(this._spritesContainer),
                          this._stage.addChild(this._secondaryTilesContainer),
                          this._stage.addChild(this._textContainer),
                           this._stage.addChild(this._container),
                           this._allTilesContainer.addChild(this._tilesContainer),
                           this._allTilesContainer.addChild(this._secondaryTilesContainer),
                           this._container.addChild(this._allTilesContainer),

                           this._rotation = .3,
                           this.initTiles(),
                           this.initSprites()
                   },
                   initTiles: function()
                   {

                       this._topTiles = new Array(),
                       this._bottomTiles = new Array(),
                       this._tiles = new Array();
                       for (var t = 0; t < this.content.nav.links.length + 2; t++)
                       this._tiles.push({
                           graphic: new PIXI.Graphics(),
                           bgGraphic: new PIXI.Graphics(),
                           x: 0,
                           y: 0,
                           w: 0,
                           h: 0
                       }),
                       this._tilesContainer.addChild(this._tiles[t].graphic),
                        this._tilesContainer.addChild(this._tiles[t].bgGraphic);
                       for (var e = 0; e < this.content.nav.links.length + 1; e++)
                        this._topTiles.push({
                           graphic: new PIXI.Graphics(),
                           x: 0,
                           y: 0,
                           w: 0,
                           h: 0
                       }),
                        this._bottomTiles.push({
                           graphic: new PIXI.Graphics(),
                           x: 0,
                           y: 0,
                           w: 0,
                           h: 0
                       }),
                       this._secondaryTilesContainer.addChild(this._topTiles[e].graphic),
                        this._secondaryTilesContainer.addChild(this._bottomTiles[e].graphic);
                       this._tweenX =PIXI.tweenManager.createTween(this._tilesContainer),
                        this._tweenXInversed =PIXI.tweenManager.createTween(this._secondaryTilesContainer),
                         this._tweenTextX = PIXI.tweenManager.createTween(this._textContainer),
                         this._tweenSpritesContainer =PIXI.tweenManager.createTween(this._spritesContainer),
                          this.drawTiles()
                   },
                   initSprites: function()
                   {
                       var t = this;
                       this._backgrounds = new Array();
                       for (var e = 0; e < this.content.nav.links.length; e++)
                       {
                           var n = PIXI.Texture.fromImage(this.content.nav.links[e].image.src),
                               r = new PIXI.Sprite(n);
                           this._backgrounds.push({
                               sprite: r,
                               tween: PIXI.tweenManager.createTween(r),
                               w: this.content.nav.links[e].image.width,
                               h: this.content.nav.links[e].image.height,
                               isAnimating: !1,
                               animAlphaRatio: 0,
                               currAnimAlphaRatio: 0
                           }),
                            this._spritesContainer.addChild(this._backgrounds[e].sprite),
                            this._container.addChild(this._spritesContainer),
                             this._backgrounds[e].sprite.alpha = 0
                       }
                       setTimeout(function() {
                           t.onResize()
                       }, 150)
                   },
                   onResize: function()
                   {
                    this.debug&& console.log("App-nav-onResize call start");
                       if (this._renderer && this._backgrounds)
                        {
                             this.debug&&console.log("App-nav-onResize call start Rendered start ");
                           var t = this.$root.winWidth,
                               e = this.$root.winHeight,
                               n = this._sceneWidth / this._sceneHeight,
                               r = t / n > e,
                               i = r ? t : e * n,
                               s = r ? t / n : e,
                               o = i / this._sceneWidth,
                               a = .5 * (i - this._sceneWidth) - .5 * (i - t),
                               u = .5 * (s - this._sceneHeight) - .5 * (s - e);
                           this._renderer.view.style.transform = "translateX(" + a + "px) translateY(" + u + "px) scale(" + o + ")";
                           for (var l = 0; l < this._backgrounds.length; l++)
                           this._backgrounds[l].sprite.width = this._sceneWidth + .35 * this._sceneWidth,
                           this._backgrounds[l].sprite.height = this._sceneHeight + .35 * this._sceneHeight;

                           this.eventHub.$emit("set:headerPageSize", this._backgrounds[this.activeIndex].sprite.width - .2 * this._backgrounds[this.activeIndex].sprite.width,
                           this._backgrounds[this.activeIndex].sprite.height - .2 * this._backgrounds[this.activeIndex].sprite.height, a, u, o),
                           this._renderer.resize(this._sceneWidth, this._sceneHeight)
                              this.debug&&console.log("App-nav-onResize call start Rendered start aftter call resize");
                       }
                   },
                   drawTiles: function()
                   {
                     var t = this._sceneWidth, e = this._sceneHeight;
                       for (var  n = 0; n < this._tiles.length; n++)
                       {
                           var r = .7 * t * n + 100 * (n + 1),
                               i = .35 * e * .5,
                               s = .7 * t,
                               o = .65 * e;
                           this._tiles[n].graphic.clear(),
                           this._tiles[n].graphic.beginFill(16777215),
                           this._tiles[n].graphic.drawRect(r, i, s, o),
                           this._tiles[n].graphic.endFill(),
                           this._tiles[n].bgGraphic.clear(),
                           this._tiles[n].bgGraphic.beginFill(2371387),
                           this._tiles[n].bgGraphic.drawRect(r, i, s, o),
                           this._tiles[n].bgGraphic.endFill()
                       }
                       for (var a = 0; a < this._topTiles.length; a++)
                        {
                          this.debug&&console.log("go inside draw tiles _topTiles:"+a);
                           var u = .75 * t * a + 100 * (a + 1),
                               l = .75 * t,
                               c = .65 * e;
                           this._topTiles[a].graphic.clear(),
                           this._topTiles[a].graphic.beginFill(2371387),
                           this._topTiles[a].graphic.drawRect(u, 75 - c, l, c),
                           this._topTiles[a].graphic.endFill(),
                           this._bottomTiles[a].graphic.clear(),
                           this._bottomTiles[a].graphic.beginFill(2371387),
                            this._bottomTiles[a].graphic.drawRect(u, e - 75, l, c),
                            this._bottomTiles[a].graphic.endFill()
                       }
                       this._secondaryTilesContainer.position.x = -.5 * t * (this._tiles.length - 1)
                   },
                   onEnterframe: function()
                   {

                       if (this._isRendering)
                       {
                           this.debug&&console.log("Nav On Enter Frame");
                           PIXI.tweenManager.update();
                           for (var t = 0; t < this._backgrounds.length; t++)
                           this._backgrounds[t].isAlphaAnimating && this._backgrounds[t].animAlphaRatio < 1

                           ?
                            this._backgrounds[t].animAlphaRatio += .015

                            :
                            !this._backgrounds[t].isAlphaAnimating && this._backgrounds[t].animAlphaRatio > 0 && (this._backgrounds[t].animAlphaRatio -= .025),
                            this._backgrounds[t].currAnimAlphaRatio = (0, clamp)(this._backgrounds[t].animAlphaRatio, 0, 1),
                            this._backgrounds[t].sprite.alpha = 1 * this._backgrounds[t].currAnimAlphaRatio;

                            this._isRedirecting && this._inAnimRatio <= 1
                            ?
                            (this._inAnimRatio += .015, this._currInAnimRatio = cubicu((0, clamp)(this._inAnimRatio, 0, 1)),
                             //console.log("this._currInAnimRatio :" + this._currInAnimRatio),
                            this._container.rotation = this._rotation - this._rotation * this._currInAnimRatio,
                            this._container.position.y = .3 * -this._sceneHeight + .3 * this._sceneHeight * this._currInAnimRatio,
                            this._allTilesContainer.scale.x = 1 + .55 * this._currInAnimRatio, this._allTilesContainer.scale.y = 1 + .55 * this._currInAnimRatio,
                             this._allTilesContainer.position.x = .525 * -this._sceneWidth * this._currInAnimRatio,
                              this._allTilesContainer.position.y = -.275 * this._sceneHeight * this._currInAnimRatio,
                            this._spritesContainer.scale.x = 1 - .2 * this._currInAnimRatio,
                            this._spritesContainer.scale.y = 1 - .2 * this._currInAnimRatio)
                             :
                              this._isAnimating && (
                              this._outAnimRatio += .015,
                              this._currOutAnimRatio =  cubicu((0, clamp)(this._outAnimRatio, 0, 1)),
                              //console.log("this._currOutAnimRatio :"+this._currOutAnimRatio),
                              this._container.rotation = this._rotation * this._currOutAnimRatio,
                               this._container.position.y = .3 * -this._sceneHeight + .3 * this._sceneHeight - .3 * this._sceneHeight * this._currOutAnimRatio,
                               this._allTilesContainer.scale.x = 1.55 - .55 * this._currOutAnimRatio,
                              this._allTilesContainer.scale.y = 1.55 - .55 * this._currOutAnimRatio,
                              this._allTilesContainer.position.x = .525 * -this._sceneWidth + .525 * this._sceneWidth * this._currOutAnimRatio,
                              this._allTilesContainer.position.y = -.275 * this._sceneHeight - -.275 * this._sceneHeight * this._currOutAnimRatio,
                              this._spritesContainer.scale.x = .8 + .2 * this._currOutAnimRatio,
                               this._spritesContainer.scale.y = .8 + .2 * this._currOutAnimRatio),
                              this._outAnimRatio > 1 && (this._isAnimating = !1),
                              this._renderer.render(this._stage)
                       }
                   },
                   setInitialState: function() {
                       this._container.rotation = this._rotation,
                        this._spritesContainer.alpha = 1,
                        this._container.position.y = .3 * -this._sceneHeight + .3 * this._sceneHeight,
                        this._tilesContainer.position.x = -(.7 * this._sceneWidth + 100) * this.activeIndex + .5 * -this._sceneWidth, this._secondaryTilesContainer.position.x = -.7 * this._sceneWidth * (this._tiles.length - 1 - this.activeIndex) + .5 * this._sceneWidth,
                        this._allTilesContainer.scale.x = 1.55,
                        this._allTilesContainer.scale.y = 1.55,
                        this._allTilesContainer.position.x = .525 * -this._sceneWidth,
                        this._allTilesContainer.position.y = -.275 * this._sceneHeight,
                         this._spritesContainer.scale.x = .8,
                          this._spritesContainer.scale.y = .8;
                       for (var t = 0; t < this._backgrounds.length; t++)
                        this._backgrounds[this.activeIndex].sprite.alpha = 0;
                       this._backgrounds[this.activeIndex].sprite.mask = this._tiles[this._translationIndex + 1].graphic
                   },
                   onItemOver: function(t) {
                     //console.log(t);
                        var e = this;
                       //console.log(e);
                      // console.log(e._backgrounds[t]);
                       if (!this._isRedirecting) {
                           if (this._isAnimating) return void setTimeout(function() {
                               e.onItemOver(t)
                           }, 50);
                           clearTimeout(n);
                           var n = setTimeout(function() {
                               t > e.activeIndex
                                ?
                                (e._direction = 1, e._translationIndex += e._direction, e.translateSprite(e._backgrounds[t].tween, t))
                                :
                                 t < e.activeIndex && (e._direction = -1, e._translationIndex += e._direction, e.translateSprite(e._backgrounds[t].tween, t)),
                               e._diffIndex = Math.abs(e.activeIndex - t),
                                e._backgrounds[e.activeIndex].isAlphaAnimating = !1,
                                 e._backgrounds[t].isAlphaAnimating = !0,
                                 e.activeIndex = t,
                                 e._backgrounds[e.activeIndex].sprite.mask = e._tiles[e._translationIndex + 1].graphic,
                                  e.translateTilesContainer(PIXI.tween.Easing.linear()),
                                  e.translateInversedTilesContainer()
                           }, 150)
                       }
                   },
                   onItemClick: function(t)
                   {
                      this.eventHub.$emit("toggle:nav"),
                       router.push(this.content.nav.links[t].href)
                   },
                   onActiveChange: function()
                    {
                       var t = this;
                       clearTimeout(this._timerActive), clearTimeout(this._timerInactive),
                        this.isActive ? (this._isRendering = !0,
                          this.$el.classList.remove("is-leaving"),
                         this._isRedirecting = !1,
                         this._outAnimRatio = 0,
                         this.$el.style.display = "block",
                         this.activeIndex = this.activePageIndex,
                          this._translationIndex = this.activePageIndex,
                          this._backgrounds[this.activeIndex].isAlphaAnimating = !0,
                           this.eventHub.$emit("disable:scroll"),
                           this.setInitialState(),
                           this._timerActive = setTimeout(function()
                           {
                           t.$el.classList.add("is-active"), t._isAnimating = !0
                       }, 50)) : (this.activeIndex === this.activePageIndex && this.$el.classList.add("is-same-page"), this._isAnimating = !1, this._isRedirecting = !0, this._inAnimRatio = 0, this.$el.classList.add("is-leaving"), this.$el.classList.remove("is-active"),
                       this._timerInactive = setTimeout(function() {
                           t._isRendering = !1, t.$el.style.display = "none", t.$el.classList.remove("is-same-page"), t._outAnimRatio = 0
                       }, this.activeIndex === this.activePageIndex ? 2300 : 2e3))
                   },
                   translateSprite: function(t, e)
                   {
                       t.stop().clear(),
                       t.time = 2700,
                       t.easing = PIXI.tween.Easing.outQuint(), t.from({
                           x: this._backgrounds[e].sprite.position.x + .3 * this._sceneWidth * this._direction
                       }), t.to({
                           x: 0
                       }), t.loop = !1, t.start()
                   },
                   translateTilesContainer: function(t)
                   {
                       this._tweenX.stop().clear(),
                        this._tweenX.time = 2500,
                         this._tweenX.easing = PIXI.tween.Easing.outQuart(),
                         this._tweenX.from({
                           x: this._tilesContainer.position.x
                       }),
                        this._tweenX.to({
                           x: -(.7 * this._sceneWidth + 100) * this._translationIndex + .5 * -this._sceneWidth
                       }), this._tweenX.loop = !1, this._tweenX.start()
                   },
                   translateInversedTilesContainer: function(t)
                   {
                       this._tweenXInversed.stop().clear(),
                        this._tweenXInversed.time = 2e3,
                        this._tweenXInversed.easing = PIXI.tween.Easing.outQuart(),
                        this._tweenXInversed.from({
                           x: this._secondaryTilesContainer.position.x
                       }), this._tweenXInversed.to({
                           x: -.7 * this._sceneWidth * (this._tiles.length - 1 - this._translationIndex) + .5 * this._sceneWidth
                       }), this._tweenXInversed.loop = !1, this._tweenXInversed.start()
                   }
               }
}

</script>



// WEBPACK FOOTER //
// src/components/app-nav/index.vue